import styled from "styled-components";

const Wrapper = styled.div`
  position: relative;

  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;

  margin-top: 1rem;
`;

export default Wrapper;
